/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { type Theme, getColor, getBodyStyle } from 'styles/theme';

export const NativoToutWrapper = styled.div<{ theme: Theme }>`
  min-height: 200px;
  padding: 16px 0;
    
  &:has(> div:empty) {
    display: none;
  }
  
  @media (${breakpoint.mdMax}) {
    min-height: 270px;
  }
  @media (${breakpoint.mmMin}) and (${breakpoint.mdMax}) {
    max-height: 570px;
  }
`;

export const NativoEyebrow = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'small' }, 'semiBold')}
  color: ${getColor('textAccentPrimary')};
  margin-top: 15px;
  text-transform: uppercase;
`;

export const ImagePlaceholder = styled.div<{ theme: Theme }>`
  flex: 0 0 40%;
  img {
    aspect-ratio: 3/2;
    height: auto;
    object-fit: cover;
    width: 100%;
    background-color: ${getColor('neutralLightGray1')};
  }

  @media (${breakpoint.mdMin}) {
    flex: 0 0 30%;
  }
`;

export const GrayPlaceholder = styled.div<{ theme: Theme }>`
  aspect-ratio: 3/2;
  background-color: ${getColor('neutralLightGray3')};
`;
